<template>
  <div class="tahun-ajaran-component">
    <div class="tahun-ajaran-body">
      <b-form data-vv-scope="tahun-ajaran-form">
        <b-form-group label="Tahun Ajaran" label-for="name" label-cols-sm="4" label-align-sm="left">
          <b-form-input id="tahun-ajaran-name" name="name" data-vv-as="Tahun Ajaran" v-model="tahun_ajaran_form.name" type="text" placeholder="Tahun Ajaran" v-validate="'required'" autocomplete="off"></b-form-input>
          <span :class="{ 'error-validation': errors.first('tahun-ajaran-form.name') }">{{ errors.first("tahun-ajaran-form.name") }}</span>
        </b-form-group>
        <b-form-group label="Sedang Berjalan ?" label-for="is_current" label-cols-sm="4" label-align-sm="left">
          <b-form-select v-model="tahun_ajaran_form.is_current" name="is_current" v-validate="'required'" value-field="id" placeholder="Sedang berjalan ?" text-field="name" data-vv-as="Sedang berjalan ?" :options="sedangList">
            <b-form-select-option :value="null" disabled>Pilih Opsi</b-form-select-option>
          </b-form-select>
          <span :class="{ 'error-validation': errors.first('tahun-ajaran-form.is_current') }">{{ errors.first("tahun-ajaran-form.is_current") }}</span>
        </b-form-group>
        <b-form-group label="Tanggal Mulai Pembelajaran" label-for="start_date" label-cols-sm="4" label-align-sm="left">
          <b-form-datepicker id="start-date" v-model="tahun_ajaran_form.start_date" name="start_date" data-vv-as="Tanggal Mulai Pembelajaran" v-validate="'required'" class="mb-2"></b-form-datepicker>
          <span :class="{ 'error-validation': errors.first('tahun-ajaran-form.start_date') }">{{ errors.first("tahun-ajaran-form.start_date") }}</span>
        </b-form-group>
      </b-form>
    </div>
    <hr />
    <div class="new-class-footer d-flex justify-content-end">
      <square-loader :loading="showLoader" :color="'#ca062a'" :size="'30px'"></square-loader>
      <b-button v-if="!showLoader" variant="outline-danger" size="md" style="width: 25%" @click="hideFormModal">BATAL</b-button>
      <b-button v-if="!showLoader" variant="primary" size="md" style="width: 25%" @click.prevent="saveData">SIMPAN</b-button>
    </div>
  </div>
</template>

<script>
import { EventBus } from "@/eventBus.js";
import SquareLoader from "vue-spinner/src/SquareLoader.vue";
export default {
  props: {
    id: {
      type: String,
      default: null,
    },
    detail: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  components: {
    SquareLoader,
  },
  data() {
    return {
      showLoader: false,
      tahun_ajaran_form: {
        name: this.id ? this.detail.name : null,
        start_date: this.id ? this.detail.start_date : null,
        is_current: this.id ? this.detail.is_current : 0,
      },
      sedangList: [
        {
          id: 0,
          name: "Tidak",
        },
        {
          id: 1,
          name: "Ya",
        },
      ],
    };
  },
  methods: {
    resetForm() {
      (this.tahun_ajaran_form.name = this.id ? this.detail.name : null),
        (this.tahun_ajaran_form.start_date = this.id ? this.detail.start_date : null),
        (this.tahun_ajaran_form.is_current = this.id ? this.detail.is_current : 0),
        this.$validator.reset();
    },
    hideFormModal() {
      EventBus.$emit("hideFormModal", true);
      this.resetForm();
    },
    async saveData() {
      let scope = "tahun-ajaran-form";
      this.$validator.validateAll(scope).then((valid) => {
        if (valid) {
          if (this.id) {
            this.tahun_ajaran_form.id = this.id;
            this.updateTahunAjaran(scope);
          } else {
            this.addTahunAjaran(scope);
          }
        }
      });
    },
    async updateTahunAjaran(scope) {
      this.showLoader = true;
      let form = this.tahun_ajaran_form;
      this.$store
        .dispatch("updateTahunAjaran", form)
        .then((res) => {
          this.showLoader = false;
          this.$store.dispatch("getTahunAjaranList");
          this.hideFormModal();
          this.$swal.fire("Success", res.message, "success");
        })
        .catch((err) => {
          let error = err.response;
          this.showLoader = false;
          if (error.status == 400) {
            this.errorValidate(error.data, scope);
          }
          this.$swal.fire("Failed", err.response.data.message, "error");
        });
    },
    async addTahunAjaran(scope) {
      this.showLoader = true;
      let form = this.tahun_ajaran_form;
      this.$store
        .dispatch("addTahunAjaran", form)
        .then((res) => {
          this.showLoader = false;
          this.$store.dispatch("getTahunAjaranList");
          this.hideFormModal();
          this.$swal.fire("Success", res.message, "success");
        })
        .catch((err) => {
          let error = err.response;
          this.showLoader = false;
          if (error.status == 400) {
            this.errorValidate(error.data, scope);
          }
          this.$swal.fire("Failed", err.response.data.message, "error");
        });
    },
  },
  created() {
    EventBus.$on("resetForm", (val) => {
      if (val) {
        this.resetForm();
      }
    });
  },
};
</script>
